import store from 'shared/store';
import { createApp } from 'vue';
import { initFormKitSchema } from 'shared/utils/initFormSchema';
import DeliveryCheckout from './deliveryCheckout.vue';
import CheckoutModalLogin from 'multisite/components/checkout/checkoutModalLogin.vue';
import ProgressBar from 'shared/components/progressBar/progressBar.vue';

import "../Styles/_c-global-checkout.scss";

const formEl = document.querySelector('[data-feature="globalCheckoutDeliveryStep"]');
if (formEl) {
	const app = createApp({
		name: 'GlobalCheckoutDeliveryStep',
	});
	app.use(store);

	app.component('delivery-checkout', DeliveryCheckout);
	app.component('checkout-modal-login', CheckoutModalLogin);
	app.component('progress-bar', ProgressBar);

	initFormKitSchema(app);
	app.mount(formEl);
}
